import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "15",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M0 7.75c0-3.855 3.117-7 7-7 3.855 0 7 3.145 7 7 0 3.883-3.145 7-7 7-3.883 0-7-3.117-7-7m4.594.875h-2.79a5.29 5.29 0 0 0 4.321 4.32v-2.379zm3.281 1.941v2.38a5.29 5.29 0 0 0 4.293-4.321h-2.79zm1.75-3.691h2.543C11.758 4.415 9.598 2.5 7 2.5a5.27 5.27 0 0 0-5.195 4.375h2.57l.191-.383A.84.84 0 0 1 5.332 6h3.309c.328 0 .629.191.765.492z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }